export enum EmoteProvider {
  Twitch,
  BTTV,
}

export type EmoteIndicesTwitch = { [emoteid: string]: string[] };
